import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTActionMenu {
    $onChanges() {
        this.setupValues();
    }

    setupValues(){
        if (this.buttons && this.buttons.length > 0) {
            this.firstButton = this.buttons[0];
            this.areOtherButtonsExist = this.buttons.length > 1;

            this.otherButtons = this.buttons.slice(1, this.buttons.length);
        }
    }

    onButtonClick(button) {
        this.onClick({ button });
    }
}

export const TftActionMenuConfiguration = {
    template,
    bindings: {
        buttons: '<',
        onClick: '&',
    },
    controller: TFTActionMenu,
    controllerAs: 'actionMenuCtrl',
};

angular.module('TALENYA-FE').component('tftActionMenu', TftActionMenuConfiguration);
